<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <v-toolbar-title
                ><h3 style="overflow-wrap: normal">
                    Libro diario
                </h3></v-toolbar-title
            >
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    to="/guardar-libro-diario"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo asiento</span>
        </v-tooltip>
        

        <!--Filtros-->
        <v-row>
            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>

            <v-col cols="12" md="4">
                <v-btn color="primary" class="white--text" @click="getDatos()">
                    Filtrar
                </v-btn>
                <v-btn
                    color="red"
                    class="white--text"
                    @click="
                        filtros_prueba = {};
                        getDatos();
                    "
                >
                    Limpiar filtros
                </v-btn>
                <!-- <v-btn color="success" @click="ExportExcel">
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn> -->
            </v-col>
        </v-row>

        <v-data-table
            @click:row="handleClick"
            dense
            v-model="selected"
            show-select
            :loading="loading"
            :headers="headers"
            :items="datos"
            item-key="id"
            :options.sync="options"
            class="elevation-1 pointer"
            @update:options="onOptionsUpdate"
            :server-items-length="total"
        >
            <!-- <template v-slot:item.conocido="{ item }">
                <span>{{ obtenerConocido(item) }}</span>
            </template> -->
            <template v-slot:item.documento="{ item }">
                <a v-if="item.factura_id != null" :href="`api/pdf-factura/${item.factura_id}`" target="_blank">
                    <v-icon small class="mr-2" color="red" style="font-size: 25px"
                        title="PDF">mdi-pdf-box</v-icon>
                </a>
                <a v-if="item.factura_entrante_id != null"
                    :href="`api/pdf-factura-entrante/${item.factura_entrante_id}`" target="_blank">
                    <v-icon small class="mr-2" color="red" style="font-size: 25px"
                        title="PDF">mdi-pdf-box</v-icon>
                </a>
            </template>
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.debe="{ item }">
                <span>{{ item.debe | format_precio }}</span>
            </template>
            <template v-slot:item.haber="{ item }">
                <span>{{ item.haber | format_precio }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        style="pointer-events: none; font-size: 25px"
                        small
                        class="mr-2"
                        color="red"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <v-row align="end">
            <v-col align="end" cols="12">
                <v-btn
                    v-if="selected.length > 0"
                    @click="deleteMultipleLineasDialog = true"
                    :disabled="isloading"
                    color="red"
                    class="white--text mt-4"
                    >Eliminar seleccionados</v-btn
                >
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteAsientoLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_comercial" max-width="1000px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear cliente
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.razon_social"
                                label="Razón social"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.nombre_comercial"
                                label="Nombre del comercial"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="cliente.cif"
                                label="CIF"
                                required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="checkCliente()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DeleteDialogVue 
            v-model="deleteMultipleLineasDialog" 
            @delete="EliminarSeleccionados"
        />

        <!-- <busqueda-cliente v-model="show_busqueda"></busqueda-cliente> -->
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";
// import BusquedaCliente from "./BusquedaCliente.vue";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import DeleteDialogVue from "../../albaran_venta/componentes/DeleteDialog.vue"
export default {
    data() {
        return {
            loading: false,
            rol: 0,
            isMobile: false,
            dialog_comercial: false,
            dialog: false,

            filtros_prueba: {},
            filter_headers: [
                {
                    title: "Fecha",
                    type: "date",
                    active: false,
                    model: "fecha",
                },
            ],
            
            selected: [],
            datos: [],
            headers: [
                {
                    text: "Asiento",
                    value: "apunte_contable_id",
                    sortable: true,
                },
                { text: "Linea", value: "linea", sortable: false },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Tipo", value: "tipo", sortable: false },
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Documento", value: "documento", sortable: false },
                {
                    text: "Cuenta contable",
                    value: "numero_cuenta",
                    sortable: false,
                },
                {
                    text: "Nombre de la cuenta contable",
                    value: "nombre_cuenta",
                    sortable: false,
                },
                { text: "Debe", value: "debe", sortable: false },
                { text: "Haber", value: "haber", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: []
            },
            total: 0,

            headers_mobile: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Estado", value: "estado.nombre", sortable: false },
                {
                    text: "Producto interesado",
                    value: "interesado.nombre",
                    sortable: false,
                },
                { text: "Acciones", value: "action", sortable: false },
            ],
            cliente: {
                cif: null,
                razon_social: "",
                nombre_comercial: "",
            },
            selectedItem: null,

            deleteMultipleLineasDialog: false,

            // Auxiliares
            /*sortBy: '',
            sortDesc: true,

            cantidad: 100,
            filtros: {
                validacion: 0,
            },
            show_busqueda: false,
            savedSortBy: null,
            savedSortDesc: null,
            agentes: [],
            headers_agente: [
                {
                    text: "#",
                    value: "id",
                    sortable: true,
                },
                {
                    text: "Nombre",
                    value: "nombre_comercial",
                    sortable: false,
                },
                { text: "Fecha Alta", value: "created_at", sortable: false },
                { text: "Estado", value: "estado.nombre", sortable: false },
                { text: "CIF/NIF", value: "cif", sortable: false },
                {
                    text: "Producto interesado",
                    value: "interes",
                    sortable: false,
                },
                { text: "Acciones", value: "action", sortable: false },
            ],*/
        };
    },
    mounted() {
        this.checkMobileView();
        // Listen for window resize events
        window.addEventListener("resize", this.checkMobileView);
    },
    beforeDestroy() {
        // Remove the resize event listener when the component is destroyed
        window.removeEventListener("resize", this.checkMobileView);
    },

    created() {
        // this.getEstadosPotencial();
        this.rol = localStorage.getItem("role");
        // this.getAgentes();

        this.getDatos();
    },
    watch: {
        "$route.meta.rol": function (val) {
            this.getDatos();
        },
    },
    methods: {
        // Comprobar si es mvista movil o pc
        checkMobileView() {
            this.isMobile = window.innerWidth <= 768; // Set the breakpoint value as per your needs
        },

        // Acciones del listado
        getDatos() {
            this.loading = true;
            // let filtros = this.filterString;

            axios
                .get(`api/get-apuntes`, {
                    params: {
                        page: this.options.page,
                        rowsPerPage: this.options.itemsPerPage,
                        sortBy: this.options.sortBy[0],
                        sortDesc: this.options.sortDesc[0],
                        ...this.filtersParams
                    }
                })
                .then(
                    (res) => {
                        const response = res.data.success;
                        this.datos = response.data;
                        this.total = response.total;
                        this.loading = false;
                    },
                    (err) => {
                        this.$custom_error(err.response.data.error);
                        this.loading = false;
                    }
                );
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions

            if(this.options.sortBy.length > 0){
                this.sortBy = this.options.sortBy[0];
                // if(this.sortBy == 'apunte_contable_id'){
                //     this.sortBy = 'id';
                // }
            }else{
                this.options.sortBy = [this.sortBy]
            }
            if(this.options.sortDesc.length > 0){
                this.sortDesc = this.options.sortDesc[0];
            }else{
                this.options.sortDesc = [!this.sortDesc];
            }

            this.getDatos();
        },
        handleClick(value) {
            this.$router.push(`/guardar-libro-diario?id=${value.id}`);
        },
        openModal(item) {
            this.selectedItem = this.datos.indexOf(item);
            this.dialog = true;
        },
        deleteAsientoLinea() {
            let id = this.datos[this.selectedItem].id;
            axios.delete(`api/delete-asiento-linea/${id}`).then(
                (res) => {
                    this.$toast.sucs("Línea de asiento eliminada con éxito");
                    this.dialog = false;
                    this.getDatos();
                },
                (err) => {
                    this.$custom_error("Error eliminando la línea de asiento");
                }
            );
        },
        EliminarSeleccionados() {
            let elementos = [];
            this.selected.forEach((elemento) => {
                 // Buscar si ya existe un objeto con el mismo apunte_contable_id
                const exist = elementos.find(item => item.apunte_contable_id === elemento.apunte_contable_id);
                
                if(exist){
                    // Si existe, simplemente agregamos el id a las líneas
                    exist.lineas.push(elemento.id);
                }else{
                    // Si no existe, creamos un nuevo objeto y lo agregamos a 'elementos'
                    elementos.push({
                        apunte_contable_id: elemento.apunte_contable_id,
                        lineas: [elemento.id] // Aquí directamente incluimos el id en la creación
                    });
                }
            });
            
            axios.post(`api/delete-asiento-lineas`, { elementos: elementos }).then(
                (res) => {
                    const message = res.data.success
                    this.$toast.sucs(message);
                    this.deleteMultipleLineasDialog = false;
                    this.getDatos();
                    this.selected = [];
                },
                (error) => {
                    this.$custom_error(error.data.response.error);
                }
            );
        },
    
        // Metodo auxiliar
        checkCliente() {
            axios.post(`api/check-cliente-comercial`, this.cliente).then(
                (res) => {
                    //console.log(res.data);
                    if (res.data.status) {
                        this.$router.push(
                            `${this.formpath}?rs=${this.cliente.razon_social}&cif=${this.cliente.cif}&nombre=${this.cliente.nombre_comercial}`
                        );
                    } else {
                        this.$custom_error(res.data.msg);
                    }
                },
                (res) => {
                    this.$custom_error("Error consultando el cliente");
                }
            );
        },
        

        // FUNCIONES EN DESUSO
        /*getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.filter_headers[2].items = res.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[1].items = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                    this.agentes = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        ExportExcel() {
            let filtros = this.filterString;

            axios
                .get(
                    `/api/excel-cliente?rol=${this.$route.meta.rol}${filtros}`,
                    { responseType: "blob" }
                )
                .then((response) => {
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "clientes.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });
        },
        obtenerConocido(item) {
            let nombre = "";
            this.conocido.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },
        obtenerInteres(item) {
            let nombre = "";
            this.productos.forEach((element) => {
                if (element.id == item.id) {
                    nombre = element.nombre;
                }
            });
            return nombre;
        },
        showBusqueda() {
            this.show_busqueda = true;
        },
        getRowClass(item) {
            if (item.agentes.length > 0)
                if (item.agentes[0].agente_relation != null)
                    if (item.agentes[0].agente_relation.estadistica == 0) {
                        return "yellow";
                    }

            return "pointer";
        },
        openModalComercial(item) {
            this.dialog_comercial = true;
        },
        exportAll() {
            axios
                .get("/api/export-clientes", {
                    responseType: "blob",
                })
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportSelected() {
            let ids = [];
            this.selected.forEach((elemento) => {
                ids.push(elemento.id);
            });
            axios
                .post(
                    "/api/export-clientes",
                    { ids: ids },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        exportFiltered() {
            let ids = [];

            axios
                .post(
                    "/api/export-clientes-filtered",
                    { agente: this.filtros.id_agente },
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    this.downloadFile(response);
                })
                .catch(error);
        },
        downloadFile(response) {
            let blob = new Blob([response.data], { type: "xlsx" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        },*/
    },
    filters: {},
    components: {
        // BusquedaCliente,
        FilterComponentVue,
        DeleteDialogVue
    },
    computed: {
        filtersParams() {
            let params = {};
            
            if (this.filtros_prueba.search) {
                params.busqueda = this.filtros_prueba.search;
            }
            
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (this.filtros_prueba[head.model].start) {
                            params[`${head.model}_desde`] = this.filtros_prueba[head.model].start;
                        }
                        if (this.filtros_prueba[head.model].end) {
                            params[`${head.model}_hasta`] = this.filtros_prueba[head.model].end;
                        }
                    } else if (this.filtros_prueba[head.model].value || this.filtros_prueba[head.model].nombre) {
                        params[head.model] = this.filtros_prueba[head.model].value || this.filtros_prueba[head.model].nombre;
                    }
                }
            });

            return params;
        },
        formpath: function () {
            return `guardar-${
                this.$route.meta.rol == 1 ? "potencial" : "cliente"
            }`;
        },
        isloading: function () {
            return this.$store.getters.getloading
        },

        /*filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else {
                        if (
                            (this.filtros_prueba[head.model].value != "" &&
                                this.filtros_prueba[head.model].value !=
                                    null) ||
                            (this.filtros_prueba[head.model].nombre != "" &&
                                this.filtros_prueba[head.model].nombre != null)
                        ) {
                            filtros += `&${head.model}=${
                                this.filtros_prueba[head.model].value
                            }`;
                        }
                    }
                }
            });
            return filtros;
        },*/
    },
};
</script>
